import React from "react";
import Image from "gatsby-image";
import {ArticlePhotos} from "./ArticlePhotos";
import {useAuthorsData} from "../../Authors/useAuthorsData";
import OgImage from "../../../../assets/images/blog/article_10/od-kiczu-do-perelki-krotka-historia-klapek-kubota_og.png";

export const ArticleData = () => {
  const images = ArticlePhotos();
  const authors = useAuthorsData();
  return {
    date: "14.09.2021r",
    category: "marketing, rebranding",
    title: "Wzorcowy przykład rebrandingu, czyli krótka historia klapek Kubota",
    description:
      "Brzydactwo, koszmar, ohydztwo, obciach, frajerstwo. Takie przymiotniki przychodziły nam do głowy, gdy na stopach sąsiada robiącego remont mieszkania letnią porą widzieliśmy niebieskie lub czarne piankowe klapki z krzykliwą nazwą \"KUBOTA\". Dziś jednak bijemy się w piersi - zwłaszcza wówczas, gdy wyraziste w swym charakterze klapki przyodziewają smukłe stopy pięknych modelek. Kubota to obecnie marka premium. A jej historia udowadnia, dlaczego warto przeprowadzić rebranding.",
    seo:
      "Brzydactwo, koszmar, ohydztwo, obciach, frajerstwo. Takie przymiotniki przychodziły nam do głowy, gdy na stopach sąsiada robiącego remont mieszkania letnią porą widzieliśmy niebieskie lub czarne piankowe klapki z krzykliwą nazwą \"KUBOTA\".",
    slug: "/blog/wzorcowy-przyklad-rebrandingu-czyli-krotka-historia-klapek-kubota",
    image: OgImage,
    authors: [
      authors.GabrielaBuszta
    ],
    hero: (
      <Image
        alt=""
        objectPosition={"center"}
        objectFit={"contain"}
        fluid={images.hero.childImageSharp.fluid}
      />
    ),
    text: {
      first: {
        title: "Co musi mieć marka, by być premium?",
        text: (
          <>
            Dobry i rozpoznawalny produkt i barwną historię. To z kolei przekłada się na popularność. Tych rzeczy nie brakuje w nowej strategii marki klapek Kubota. Niegdysiejszy symbol kiczu obecnie prezentuje się znakomicie - ze stylem i wyczuciem wchodzi na salony, gdzie szturmem zdobywa serca zatwardziałych przeciwników klapek. Marka przeszła gruntowny rebranding i wypracowała spójną koncepcję komunikacyjną i wizerunkową, która podoba się nie tylko dawnym wielbicielom chińskich klapek, ale również młodym miłośnikom wygody i stylu.
          </>
        ),
      },
      second: {
        title: "",
        text: (
          <>
            Każdy brand musi mieć swoją historię. Może wyrastać z pasji, tradycji, zamiłowania czy potrzeby. Najważniejsze, by pokazać charakter marki. Doskonale rozumieją to nowi właściciele firmy Kubota, którzy śmiało zagrali stereotypami dotyczącymi swojego produktu, wykorzystali jego potencjał i wypracowali taki sposób mówienia o marce, że każdy chciałby nosić nowoczesne klapki. Nowy wizerunek marki idealnie wpisał się w panujące trendy promujące wygodę, luz i multistylowość
          </>
        ),
      },
      third: {
        title: "Zmiany, zmiany i znowu zmiany...",
        text: (
          <>
            Najciekawsze w&nbsp;całej tej historii jest to, że nowi właściciele do tematu podeszli zupełnie serio. Zainwestowali w produkt i&nbsp;zamiast piankowych podkładek zapinanych na rzepy możemy cieszyć się obuwiem wykonanym ze skóry pochodzącej z&nbsp;Polski i&nbsp;Włoch. Dodatkowo warto podkreślić, że produkt jest projektowany i&nbsp;szyty w Polsce. Kubota manifestuje również swoją postawę popierającą ruch Fashion Revolution dążącego do pozytywnego oddziaływania mody na warunki życia osób, które faktycznie zajmują się szyciem i&nbsp;produkcją ubrań.
          </>
        ),
      },
      fourth: {
        title: "",
        text: (
          <>
            Idąc za ciosem, nowi właściciele marki Kubota poszerzyli asortyment o skarpetki oraz akcesoria. Tak. Skarpetki. Dawniej faktycznie skarpety były nieodłącznym elementem stylówki z chińskimi klapkami w roli głównej. Najczęściej skarpety były białe i kończyły się hen daleko pod kolanami. I to udało się ograć. W ofercie internetowego sklepu Kubota znalazły się sportowe i casualowe skarpetki, które są produkowane w jednej z łódzkich fabryk. <b>Jakość, jakość i znowu jakość</b>. Firma ta bowiem wykorzystuje maszyny dziewiarskie sprowadzone z Włoch. Ostatecznie Kubota oddaje do naszego użytku nowoczesne w stylistyce skarpetki wykonane według najnowszych trendów. Takich skarpetek nikt nie powstydzi się nosić. Zwłaszcza z klapkami.
          </>
        ),
      },
      fifth: {
        title: "",
        text: (
          <>
            Oprócz tego w sklepie internetowym Kubota znaleźć można przypinki i breloki. Oczywiście w kształcie skarpet i klapek. Czyż to nie uroczy sposób epatowania własnym produktem? Jeśli nie na nogach, to chociaż na koszulce przypnij sobie symbol polskości - klapki z wyrazistym napisem "KUBOTA". Bo tym właśnie ma stać się ten produkt.
          </>
        ),
      },
      sixth: {
        title: "Rebranding - tak to się robi",
        text: (
                 <>
                   Marka Kubota z chińskiego bubla zrobiła markę premium. A wystarczyło popracować nad produktem, stworzyć odpowiednią i spójną komunikację w kanałach social media, odnieść się do współczesnych trendów ze świata mody i … popatrzeć na siebie z dystansem. <br/>Jeśli zainspirowała Cię historia marki i tak jak Kubota chciałbyś zmienić postrzeganie swojego brandu - skontaktuj się! Opracujemy dla Ciebie nową strategię i bezboleśnie przeprowadzimy rebranding.
                 </>
               ),
      },
    },
    images: {},
  };
};
